<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          dense
          multi-sort
          :headers="tableHeaders"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          class="elevation-1">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title>Properties</v-toolbar-title>
              <v-btn icon @click="refresh">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-divider vertical class="mx-4" inset></v-divider>
              <v-text-field v-model="search" label="Cautare" class="mx-4" clearable hide-details></v-text-field>
              <v-spacer></v-spacer>
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on }">
                  <v-btn
                    color="primary"
                    dark
                    v-on="on"
                    icon>
                    <v-icon>mdi-cog</v-icon>
                  </v-btn>
                </template>
                <v-list dense flat>
                  <v-list-item-group v-model="selectedHeaders" multiple>
                    <v-list-item
                      v-for="head in headers"
                      :key="head.value"
                      :value="head.text">
                      <template v-slot:default="{ active }">
                        <v-list-item-content>
                          <v-list-item-title v-text="head.text"></v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon>
                          <v-icon small :color="active ? 'primary' : 'error'">{{ active ? 'mdi-check' : 'mdi-close' }}</v-icon>
                        </v-list-item-icon>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </v-toolbar>
          </template>
          <template v-slot:item.showifnull="{ item }">
            <v-icon :color="item.showifnull ? 'success' : 'error'">{{ item.showifnull ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </template>
          <template v-slot:item.expand="{ item }">
            <v-icon :color="item.expand ? 'success' : 'error'">{{ item.expand ? 'mdi-check' : 'mdi-close' }}</v-icon>
          </template>
          <template v-slot:item.icon.url="{ item }">
            <v-img
              :src="getIcon(item.icon)"
              lazy-src="data:image/png;base64,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"
              max-height="20"
              max-width="40"
              contain>
            </v-img>
          </template>
          <template v-slot:item.actions="{ item }">
            <div style="white-space: nowrap">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
                color="accent">
                mdi-pencil
              </v-icon>
              <v-icon
              class="mr-2"
                small
                @click="deleteItem(item)"
                color="error">
                mdi-delete
              </v-icon>
            </div>
          </template>
          <template v-slot:item.createdAt="{ item }">
            {{ (new Date(item.createdAt)).toLocaleString('ro-RO') }}
          </template>
          <template v-slot:item.updatedAt="{ item }">
            {{ (new Date(item.updatedAt)).toLocaleString('ro-RO') }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-btn
      color="primary"
      fab
      bottom
      right
      class="avz-fab"
      @click="openItemDialog">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog
      persistent
      scrollable
      v-model="itemForm"
      width="500">
      <v-card max-height="75vh">
        <v-card-title>
          <span>{{ itemAction === 'add' ? 'Adaugare' : 'Modificare' }} Property</span>
          <v-spacer></v-spacer>
          <v-btn icon small>
            <v-icon small color="error" @click="closeItemDialog">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form v-model="validForm" ref="form">
            <v-select
              :items="propertygroups"
              item-text="label"
              item-value="_id"
              label="Grup"
              :rules="required"
              v-model="item.propertygroup_id">
              <template v-slot:item="data">
                <span class="blue-grey--text">({{ data.item.apl_id.name }})</span> &nbsp;
                {{ data.item.label }}
              </template>
            </v-select>

            <v-select
              :items="['short text', 'long text', 'date', 'time', 'number', 'image', 'document']"
              label="Tip"
              :rules="required"
              v-model="item.type">
            </v-select>

            <v-text-field
              v-model.number="item.index"
              type="number"
              label="Index"
              hint="Ordine in afisarea in cadrul detaliilor markerului"
              required
              :rules="required">
            </v-text-field>

            <v-text-field
              v-model="item.label"
              label="Eticheta"
              hint="Eticheta identificare proprietate in cadrul grupului de properitati din cadrul detaliilor markerului"
              required
              :rules="required">
            </v-text-field>

            <v-textarea
              v-model="item.info"
              label="Explicatii"
              hint="Text explicatii proprietate"
              required
              :rules="required">
            </v-textarea>

            <v-switch v-model="item.expand" label="Properietate deschisa implicit">
            </v-switch>

            <v-switch v-model="item.showifnull" label="Proprietate afisata chiar si daca markerul curent nu are valoare pt aceasta proprietate">
            </v-switch>

            <v-img
              :src="getIcon(item.icon)"
              lazy-src="data:image/png;base64,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"
              height="59"
              position="center center"
              contain
              class="text-right">
            </v-img>

            <v-file-input
              ref="file"
              prepend-icon=""
              v-model="item.icon.buffer"
              label="Fisier grafic"
              persistent-hint
              accept="image/*"
              hint="Try to keep 'em optimized, pls">
            </v-file-input>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="closeItemDialog">Inchide</v-btn>
          <v-btn color="primary" @click="saveItem">Salveaza Status</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      persistent
      scrollable
      v-model="deleteItemDialog"
      width="500">
      <v-card>
        <v-card-title>Confirmati stergerea?</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          Stergerea unei proprietati va duce la stergerea informatiilor respective din fiecare marker!
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" outlined @click="cancelDelete">Anuleaza stergerea</v-btn>
          <v-btn color="primary" @click="confirmDelete">Sterge Property Group</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SERVER_URL from '@/config'
import _debounce from 'lodash.debounce'
import tableHeaders from '@/mixins/tableHeaders'

export default {
  name: 'avz-properties',
  mixins: [tableHeaders],

  data: () => ({
    propertygroups: [],

    selectedHeaders: ['id', 'APL', 'grup', 'index', 'expand', 'showifnull', 'eticheta', 'type', 'explicatii', 'icon', 'actions'],
    headers: [
      {
        text: 'id',
        value: '_id',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'APL',
        value: 'propertygroup_id.apl_id.name',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'grup',
        value: 'propertygroup_id.label',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'index',
        value: 'index',
        align: 'end',
        sortable: true,
        filterable: true
      },
      {
        text: 'eticheta',
        value: 'label',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'explicatii',
        value: 'info',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'icon',
        value: 'icon.url',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'expand',
        value: 'expand',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'showifnull',
        value: 'showifnull',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'tip',
        value: 'type',
        align: 'start',
        sortable: false,
        filterable: false
      },
      {
        text: 'creat',
        value: 'createdAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'modificat',
        value: 'updatedAt',
        align: 'start',
        sortable: true,
        filterable: true
      },
      {
        text: 'actions',
        value: 'actions',
        sortable: false,
        filterable: false
      }
    ],
    itemForm: false,
    itemAction: 'add',
    validForm: true,
    deleteItemDialog: false,
    deleteItemID: null,

    required: [val => (val !== null && val !== undefined) || 'Campul nu poate fi gol!'],

    item: {
      _id: null,
      propertygroup_id: null,
      index: 0,
      label: null,
      info: null,
      expand: false,
      showifnull: false,
      type: null,
      icon: {
        url: null,
        buffer: null
      }
    }
  }),

  computed: {
    items () {
      return this.$store.getters.propertiesItems
    },
    totalItems () {
      return this.$store.getters.propertiessTotal
    },
    loading () {
      return this.$store.getters.propertiesLoading
    },
    options: {
      get () {
        return this.$store.getters.propertiesOptions
      },
      set (value) {
        this.$store.dispatch('setPropertiesOptions', value)
      }
    },
    search: {
      get () {
        return this.$store.getters.propertiesSearch
      },
      set: _debounce(function (value) {
        this.$store.dispatch('setPropertiesSearch', value)
      }, 500)
    },
    tableHeaders () {
      return this.headers.filter(head => this.selectedHeaders.includes(head.text))
    }
  },

  methods: {
    resetForm () {
      this.$refs.form.resetValidation()
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.$refs.file.$refs.input.value = null
      this.itemAction = 'add'
    },
    closeItemDialog () {
      this.itemForm = false
      this.item = Object.assign(this.item, {}, JSON.parse(JSON.stringify(defaultItem)))
      this.resetForm()
    },
    openItemDialog () {
      this.itemForm = true
      this.itemAction = 'add'
    },
    saveItem () {
      this.$refs.form.validate()
      if (this.validForm) {
        const payload = Object.assign({}, this.item)
        this.$store.dispatch('saveProperty', payload)
        this.closeItemDialog()
      }
    },
    editItem (item) {
      this.item = Object.assign(this.item, {}, item)
      this.itemAction = 'edit'
      this.itemForm = true
    },
    deleteItem (item) {
      this.deleteItemID = item._id
      this.deleteItemDialog = true
    },
    confirmDelete () {
      const payload = this.deleteItemID
      this.$store.dispatch('deleteProperty', payload)
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    cancelDelete () {
      this.deleteItemID = null
      this.deleteItemDialog = false
    },
    getIcon (icon) {
      return SERVER_URL + icon.url + `?${new Date().getTime()}`
    },
    refresh () {
      this.$store.dispatch('fetchProperties')
    }
  },

  async mounted () {
    try {
      const propertygroups = await this.$store.dispatch('fetchAllPropertyGroups')
      this.propertygroups = Object.freeze(propertygroups)
    } catch (err) {
      console.log(err)
    }
  }
}

const defaultItem = {
  _id: null,
  propertygroup_id: null,
  index: 0,
  label: null,
  info: null,
  expand: false,
  showifnull: false,
  type: null,
  icon: {
    url: null,
    buffer: null
  }
}
</script>
